import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../../css/templateForm.scss";

export default function DeleteTemplate(props) {
  const {
    deleteEdetailCard,
    openDeleteTempModal,

    closeDeletetemplate,
    deleteId,
  } = props;

  return (
    <>
      <Modal
        show={openDeleteTempModal}
        onHide={closeDeletetemplate}
        className="delete-template"
      >
        <Modal.Body className="confirmDelete">
          <div className="deleteConfirmation-main">
            <span className="deleteConfirmation">Are you sure you want to </span>
            <span className="deleteConfirmation2 deleteConfirmation">
              delete this template
            </span>
            <span className=" deleteConfirmation"> ?</span>
            <div className="deletenote">
              {" "}
              Note: This template will be permanently deleted
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="modalActionsdelete">
          <div className="delete-template-button">
              <Button 
                type="button" 
                onClick={() => closeDeletetemplate()} 
                className="cancel-template"
                >CANCEL</Button>
              <Button 
                type="button" 
                onClick={(e) => deleteEdetailCard(deleteId)} 
                className="delete-template"
                >DELETE</Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
